<template>
    <div class="pb-10 lg:block hidden lg:pr-14">
        <div class="items-center cursor-pointer w-auto h-10 hidden lg:flex">
            <h5 class="text-24 lg:text-28 font-bold">Settings</h5>
        </div>

        <div class="text-14 text-grey-900 mt-6 h-12 pb-3 border-b border-grey-500 flex items-end mb-6">
            <p>Navigation</p>
        </div>

        <div class="">
            <template v-for="link in links">
                <div
                    :class="{
                        'border-l-2 border-grey-500 px-3 mb-3': showSubscriptionMenu && link == '/settings/subscriptions',
                    }"
                >
                    <NavLink :to="link">
                        {{ $help.capitalizeFirstLetter(link.replace('/settings/', '').replace('-', ' ')) }}
                    </NavLink>

                    <div v-if="showSubscriptionMenu && link == '/settings/subscriptions'">
                        <div class="pl-3 border-l-2 border-grey-500">
                            <DropdownV2
                                :menuPush="true"
                                :hasShadow="false"
                                :allowClickOutSide="false"
                                :loadOpen="
                                    user.subscriptions.find((s) => s.product_id == 1 && parseInt(s.id) == parseInt(subscriptionId)) != null
                                "
                            >
                                <template #button><div class="block text-15 py-2">Zapo Ads</div></template>
                                <template #menu>
                                    <div class="pl-3 border-l-2 border-grey-500">
                                        <DropdownV2
                                            v-for="(subs, ind) in ads"
                                            :menuPush="true"
                                            :hasShadow="false"
                                            :allowClickOutSide="false"
                                            :loadOpen="
                                                user.subscriptions.find(
                                                    (s) => s.product_id == 1 && parseInt(s.id) == parseInt(subscriptionId),
                                                ) != null
                                            "
                                        >
                                            <template #button>
                                                <div class="block text-15 py-2">
                                                    {{ ind }}
                                                </div>
                                            </template>

                                            <template #menu>
                                                <div class="">
                                                    <NavLink :to="'/settings/subscription/' + id" v-for="(loc, id) in subs" :open="true">
                                                        {{ loc }}
                                                    </NavLink>
                                                </div>
                                            </template>
                                        </DropdownV2>
                                    </div>
                                </template>
                            </DropdownV2>
                        </div>

                        <template v-for="subscription in user.subscriptions.filter((s) => s.product_id == 2)">
                            <NavLink :to="'/settings/subscription/' + subscription.id" :open="true" borderClass="!border-purple-500">Zapo CRM</NavLink>

                            <div
                                class="px-3 border-l-2 border-grey-500"
                                v-if="subscription.product_id == 2 && subscriptionId == subscription.id"
                            >
                                <template v-for="slink in CRMLinks(subscription.id)">
                                    <NavLink :to="slink.link" :open="true" borderClass="!border-purple-500">
                                        {{ slink.name }}
                                    </NavLink>
                                </template>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import NavLink from '~/components/customer/blocks/setting-nav-link.vue'

export default {
    props: {
        subscriptionId: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            links: ['/settings/subscriptions', '/settings/invoices', '/settings/payment-methods', '/settings/profile'],
        }
    },

    methods: {
        isActive(path) {
            return this.$route.path.indexOf(path) !== -1
        },

        CRMLinks(id) {
            return [
                // {
                //     link: '/settings/subscription/' + id + '/pipeline-stages',
                //     name: 'Pipeline stages',
                // },
                // {
                //     link: '/settings/subscription/' + id + '/default-folders',
                //     name: 'Folder setup',
                // },
                // {
                //     link: '/settings/subscription/' + id + '/lead-sources',
                //     name: 'Lead sources',
                // },
                {
                    link: '/settings/subscription/' + id + '/usage',
                    name: 'Usage history',
                },
                {
                    link: '/settings/subscription/' + id + '/call-assistant',
                    name: 'Call assistant',
                },
                {
                    link: '/settings/notifications/' + id,
                    name: 'Notifications',
                },
                {
                    link: '/settings/configuration/' + id,
                    name: 'Configuration',
                },
                {
                    link: '/settings/users/' + id,
                    name: 'Users',
                },
            ]
        },
    },

    computed: {
        user() {
            return this.$authSanctum.getUser()
        },

        showSubscriptionMenu() {
            return this.$route.meta.subMenu
        },

        ads() {
            let t = {}

            for (let s in this.user.subscriptions) {
                let sub = this.user.subscriptions[s]

                if (sub.product_id == 2) {
                    continue
                }

                if (t[sub.company.industry.name] == undefined) {
                    t[sub.company.industry.name] = {}
                }

                t[sub.company.industry.name][sub.id] = sub.location_area.name
            }

            return t
        },
    },

    components: {
        NavLink,
    },
}
</script>
